export const APP_CONFIG = {
    NAME: 'FairLegal',
    VERSION: '1.0.0',
    DESCRIPTION: 'AI-powered legal assistance platform',
} as const;

export const BREAKPOINTS = {
    LARGE_SCREEN: 1440,
    MEDIUM_SCREEN: 768,
    SMALL_SCREEN: 480,
} as const;

export const CHAT_CONFIG = {
    MAX_MESSAGE_LENGTH: 1000,
    TYPING_INDICATOR_DELAY: 1000,
    MESSAGE_TIMEOUT: 30000,
} as const;

export const API_ENDPOINTS = {
    CHAT: '/chat',
    CONVERSATIONS: '/conversations',
    AUTH: '/auth',
} as const;

export const STORAGE_KEYS = {
    AUTH_TOKEN: 'authToken',
    USER_PREFERENCES: 'userPreferences',
    CONVERSATIONS: 'conversations',
} as const; 